<template>
    <card>
        <Button type="primary" size="small" @click="addTime">新增上课时间</Button>
        <div v-for="(item,index) in timeList" :key="index" style="border-bottom: 1px solid #efefef;padding:10px;">
            <Row :gutter="5">
                <CheckboxGroup v-model="item.weekday" style="width:500px;">
                    <template v-for="count in 7">
                        <Col span="3">
                            <Checkbox :label="count">{{count|getWeekdayTxt}}</Checkbox>
                        </Col>
                    </template>
                </CheckboxGroup>
                <Col span="3">
                    <Button type="error" size="small" @click="remove(index)">删除时间</Button>
                </Col>
            </Row>
            <Row style="margin-top: 10px;">
                <Col span="24">
                    <FormItem label="上课时间段：">
                        <Select :value="item.start + ' - ' + item.end" style="width: 200px;" @on-change="timechange(item,$event)">
                            <Option v-for="(timeRange,index) in timeRangeList" :key="index" :value="timeRange.start + ' - ' + timeRange.end">{{(timeRange.start + ' - ' + timeRange.end)}}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
        </div>
    </card>
</template>
<script>

  import xmutils from '../../libs/xmutils';
  export default {
    name: 'timelist',
    props: {
      timeList:Array
    },
    data() {
      return {
      }
    },
    mounted(){
    },
    computed: {
      timeRangeList() {
        return this.$store.state.app.timeList
      }
    },
    methods:{
      addTime(){
        this.timeList.push({
          start:null,
          end:null,
          weekday:[]
        });
      },
      remove(index){
        this.timeList.splice(index,1);
      },
      timechange(item,value){
        let timeArray = value.split('-');
        item.start = timeArray[0].trim();
        item.end = timeArray[1].trim();
      }
    },
    filters: {
      getWeekdayTxt: function (value) {
        return xmutils.parseWeekDay(value);
      }
    },
  }
</script>
